import { Arquivo } from "./arquivo";

export class Evidencia {
  cD_BPM_MOVIMENTACAO_PATRIMONIAL!: number;
  nR_BPM_BEM_PATRIMONIAL!: number;
  dS_BPM_TEXTO_EVIDENCIA!: string;
  cD_BPM_ARQUIVO_PATRIMONIAL: number;
  fL_BPM_ATIVO!: number;
  fL_BPM_DELETADO!: number;
  dT_BPM_DATA_INCLUSAO_EVIDENCIA: Date;
  dS_NM_ORIGEM: string;
  dS_NM_DESTINO: string;
  dS_NM_GESTOR: string;
  dS_BPM_DESCRICAO_BEM: string;
  cD_CDU_MATRICULA_ORIGEM: number;
  cD_CDU_MATRICULA_DESTINO: number;
  cD_CDU_MATRICULA_GESTOR: number;
  dS_BPM_FILENAME_ARQUIVO_PATRIMONIAL:string;
  dS_AUTOR_EVIDENCIA:string;
}
